import _ from 'lodash';
import moment from 'moment';
import licenseService from '../../services/licenseService';
import License from '../../model/license';

const state = {
  baseUrl: '/license-upload',
  licenseList: [],
  downloadLicenseList: [],
  pagination: {},
  loading: false,
  document: null,
  license: {}
};

const actions = {
  listLicense({ dispatch, commit }, { query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('setLicenseList', { licenseList: [], pagination: {} });

    commit('startRequest');

    licenseService
      .listLicense({ query })
      .then(response => {
        commit('setLicenseList', { licenseList: response.data.rows, pagination: response.data.pagination });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  postOne({ dispatch, commit }, { license, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    licenseService
      .postOne({ license })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'New License has been uploaded.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  getOne({ dispatch, commit }, { id, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    commit('setLicense', { license: {} });

    licenseService
      .getOne({ id })
      .then(response => {
        commit('setLicense', { license: response.data });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  deleteOne({ dispatch, commit }, { id, query, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');
    licenseService
      .deleteOne({ id })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'License has been deleted successfully.'
          },
          { root: true }
        );
        dispatch('listLicense', { query });
        commit('finishRequest');
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  patchOne({ dispatch, commit }, { type, license, router, id, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');
    licenseService
      .patchOne({ type, license, id })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'license has been updated.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  download({ dispatch, commit, router }, { query = {} }) {
    dispatch('alert/clear', {}, { root: true });

    licenseService
      .listLicense({ query })
      .then(response => {
        commit('setDownloadLicenseList', {
          downloadLicenseList: response.data.rows
        });
      })
      .catch(e => {
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  uploadDocument({ dispatch, commit }, query = {}, router) {
    dispatch('alert/clear', {}, { root: true });
    const { file, fileName } = query;
    return new Promise((resolve, reject) => {
      licenseService
        .getSignedUrl({ filename: fileName, filetype: file.type, file })
        .then(response => {
          licenseService
            .uploadDocument({ url: response.data, file })
            .then(res => {
              commit('Nothing', res);
              resolve(res); 
            })
            .catch(e => {
              commit('requestFailed');
              dispatch('common/handleServiceException', { e, router }, { root: true });
              reject(e); 
            });
        })
        .catch(e => {
          commit('requestFailed');
          dispatch('common/handleServiceException', { e, router }, { root: true });
          reject(e); 
        });
    });
  },
  setDownloadListToEmpty({ commit }) {
    commit('setDownloadLicenseList', { downloadLicenseList: [] });
  }
};

const getters = {};

const mutations = {
  startRequest(state) {
    state.loading = true;
  },
  finishRequest(state) {
    state.loading = false;
  },
  requestFailed(state) {
    state.loading = false;
  },
  setLicense(state, { license }) {
    state.loading = false;
    state.license = license;
    state.license = new License({
      rowNum: 1,
      id: license._id,
      fileName: license.fileName,
      fileUrl: license.fileUrl,
      storeid: license.storeid,
      storeName: license.storeName,
      submittedByName: license.submittedByName,
      createdAt: license.createdAt,
      startDate: license.startDate === '2000-01-01T00:00:00.000Z' ? null : license.startDate,
      endDate: license.endDate === '2099-01-01T00:00:00.000Z' ? null : license.endDate
    });
  },
  setLicenseList(state, { licenseList, pagination }) {
    let row = 1;
    state.licenseList = licenseList.map(i => {
      const { _id } = i;
      const newLicense = new License({
        rowNum: row,
        id: _id,
        fileName: i.fileName,
        fileUrl: i.fileUrl,
        storeid: i.storeid || i.storeId || (i.store && (i.store.storeid || i.store.storeId)),
        storeName: i.storeName || (i.store && i.store.storeName),
        submittedByName: i.submittedByName,
        createdAt: i.createdAt,
        // this.createdAt = createdAt ? moment(createdAt).format('DD-MM-YYYY') : null;
        startDate: i.startDate === '2000-01-01T00:00:00.000Z' ? 'N/A' : moment(i.startDate).format('DD-MM-YYYY'),
        endDate: i.endDate === '2099-01-01T00:00:00.000Z' ? 'N/A' : moment(i.endDate).format('DD-MM-YYYY')
      });
      row += 1;
      return newLicense;
    });
    state.pagination = pagination;
    state.loading = false;
  },

  setDownloadLicenseList(state, { downloadLicenseList }) {
    let row = 1;
    state.downloadLicenseList = _.map(downloadLicenseList, i => {
      const { _id } = i;
      const newLicense = new License({
        rowNum: row,
        id: _id,
        fileName: i.fileName,
        fileUrl: i.fileUrl,
        storeid: i.storeid || i.storeId || (i.store && (i.store.storeid || i.store.storeId)),
        storeName: i.storeName || (i.store && i.store.storeName),
        submittedByName: i.submittedByName,
        createdAt: i.createdAt,
        startDate: i.startDate === '2000-01-01T00:00:00.000Z' ? 'N/A' : moment(i.startDate).format('DD-MM-YYYY'),
        endDate: i.endDate === '2099-01-01T00:00:00.000Z' ? 'N/A' : moment(i.endDate).format('DD-MM-YYYY')
      });
      row += 1;
      return newLicense;
    });
    state.loading = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
